import styled from 'styled-components';

export const StyledBiaxialBarChart = styled.div`
  width: 100% !important;
  height: auto;

  .recharts-wrapper .recharts-default-legend {
    width: 100% !important;
    text-align: left !important;
    position: relative !important;
    left: 122px !important;
    
    @media screen and (max-width: 1600px) {
      left: 20px;
    }
  }
  
  svg {
    margin-top: -27px;
    width: 100% !important;
    box-sizing: border-box;
    font-size: 14px !important;
    overflow: inherit;
    
    @media screen and (max-width: 1366px) {
      display: flex;
      margin: 0 auto;
      transform: scale(.9) translate3d(30px,-45px,0);
      font-size: 10px !important;
    }
    
    @media screen and (max-width: 850px) {
      transform: translate3d(0, 0, 0);
    }
    
    text {
      font-weight: bold;
    }
  }

  @media print{
    .recharts-wrapper, .recharts-default-legend {
      width: 100% !important;
      text-align: left !important;
      position: relative !important;
    }

    svg {
      margin-top: -27px;
      width: 100% !important;
      box-sizing: border-box;
      overflow: inherit;      
      display: flex;
      flex: 1;
      margin: 0 auto;
      transform: scale(.9) translate3d(30px,-45px,0);
      font-size: 14px !important;
      
      text {
        font-weight: bold;
      }
    }
  }
`;
